import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'

export const buildStore = defineStore('build', {
  id: 'build',
  state: () => ({
    build: null,
    pricing: [],
    currentPrice: null
  }),
  actions: {
    async getBuild(adas) {
      this.build = null
      this.currentPrice = null
      this.pricing = []
      const r = await api.get(`build/build?adas=${adas}`)
      this.build = r
      console.log('Got Build:', r)
      return r
    },
    async getPricing(data) {
      const r = await api.post('build/pricing', data)
      this.pricing = r.data
      return r.data
    },
    async forceDecode(vin) {
      this.build = null
      this.currentPrice = null
      this.pricing = []
      const r = await api.get(`decode/neo?vin=${vin}&force=true`)
      this.build = r
      console.log('Got New Build:', r)
      return r
    },
    async getCurrentPricing(data) {
      this.currentPrice = null
      const r = await api.post(`build/pricing`, data)
      this.currentPrice = r
      console.log('Got Current Price:', this.currentPrice)
      return this.currentPrice 
    }
  }
})